import { Card } from 'antd'
import { useState } from 'react'
import { AddNewForm } from './AddNewForm'
import ListJobTable from './ListJobTable'

type Props = { activeTab?: string }
export const ExploreOurOpportunity = ({ activeTab }: Props) => {
  const [isAddNew, setIsAddNew] = useState(false)

  return (
    <>
      <Card>
        {isAddNew ? (
          <AddNewForm onCancel={() => setIsAddNew(false)} />
        ) : (
          <ListJobTable onAddNew={() => setIsAddNew(true)} />
        )}
      </Card>
    </>
  )
}
